<template>
<div class="alerte-facture">
    <v-alert outlined text type="success" v-if="facture.solde < 0.01">Facture payée. Merci !</v-alert>

    <v-alert outlined text type="info" v-if="facture.solde >= 0.01 && facture.dejaPaye >= 0.01">Facture payée en partie. Veuillez payer le solde.</v-alert>

    <v-alert outlined text type="info" v-if="facture.solde >= 0.01 && facture.dejaPaye < 0.01">Facture à payer.</v-alert>

</div>
  

</template>

<script>
export default {
  props: {
    facture: Object
  }
}
</script>

<style>

</style>